/* eslint-disable */
/* tslint:disable */
/* auto-generated react proxies */
import { createReactComponent } from './react-component-lib';
export const PkAccordionGroup = /*@__PURE__*/ createReactComponent('pk-accordion-group');
export const PkAccordionItem = /*@__PURE__*/ createReactComponent('pk-accordion-item');
export const PkAccordionItemContent = /*@__PURE__*/ createReactComponent('pk-accordion-item-content');
export const PkAccordionItemTitle = /*@__PURE__*/ createReactComponent('pk-accordion-item-title');
export const PkAvatar = /*@__PURE__*/ createReactComponent('pk-avatar');
export const PkBadge = /*@__PURE__*/ createReactComponent('pk-badge');
export const PkBottomPanel = /*@__PURE__*/ createReactComponent('pk-bottom-panel');
export const PkBox = /*@__PURE__*/ createReactComponent('pk-box');
export const PkButton = /*@__PURE__*/ createReactComponent('pk-button');
export const PkCard = /*@__PURE__*/ createReactComponent('pk-card');
export const PkCardMedia = /*@__PURE__*/ createReactComponent('pk-card-media');
export const PkCarousel = /*@__PURE__*/ createReactComponent('pk-carousel');
export const PkCheckbox = /*@__PURE__*/ createReactComponent('pk-checkbox');
export const PkChip = /*@__PURE__*/ createReactComponent('pk-chip');
export const PkCollapse = /*@__PURE__*/ createReactComponent('pk-collapse');
export const PkColumnCharts = /*@__PURE__*/ createReactComponent('pk-column-charts');
export const PkCountdown = /*@__PURE__*/ createReactComponent('pk-countdown');
export const PkCountdownItem = /*@__PURE__*/ createReactComponent('pk-countdown-item');
export const PkCountdownTimer = /*@__PURE__*/ createReactComponent('pk-countdown-timer');
export const PkDataCard = /*@__PURE__*/ createReactComponent('pk-data-card');
export const PkDialog = /*@__PURE__*/ createReactComponent('pk-dialog');
export const PkDivider = /*@__PURE__*/ createReactComponent('pk-divider');
export const PkDonutChart = /*@__PURE__*/ createReactComponent('pk-donut-chart');
export const PkDropdown = /*@__PURE__*/ createReactComponent('pk-dropdown');
export const PkEmptyMessage = /*@__PURE__*/ createReactComponent('pk-empty-message');
export const PkIcon = /*@__PURE__*/ createReactComponent('pk-icon');
export const PkIdentifier = /*@__PURE__*/ createReactComponent('pk-identifier');
export const PkImage = /*@__PURE__*/ createReactComponent('pk-image');
export const PkJersey = /*@__PURE__*/ createReactComponent('pk-jersey');
export const PkLazy = /*@__PURE__*/ createReactComponent('pk-lazy');
export const PkLineChart = /*@__PURE__*/ createReactComponent('pk-line-chart');
export const PkListItem = /*@__PURE__*/ createReactComponent('pk-list-item');
export const PkListStatItem = /*@__PURE__*/ createReactComponent('pk-list-stat-item');
export const PkLiveIndicator = /*@__PURE__*/ createReactComponent('pk-live-indicator');
export const PkMatchFactEvent = /*@__PURE__*/ createReactComponent('pk-match-fact-event');
export const PkMatchFacts = /*@__PURE__*/ createReactComponent('pk-match-facts');
export const PkMatchHeader = /*@__PURE__*/ createReactComponent('pk-match-header');
export const PkMatchUnit = /*@__PURE__*/ createReactComponent('pk-match-unit');
export const PkMenu = /*@__PURE__*/ createReactComponent('pk-menu');
export const PkMenuItem = /*@__PURE__*/ createReactComponent('pk-menu-item');
export const PkMenuSubitem = /*@__PURE__*/ createReactComponent('pk-menu-subitem');
export const PkMixedChart = /*@__PURE__*/ createReactComponent('pk-mixed-chart');
export const PkNumStatItem = /*@__PURE__*/ createReactComponent('pk-num-stat-item');
export const PkOverlay = /*@__PURE__*/ createReactComponent('pk-overlay');
export const PkPopover = /*@__PURE__*/ createReactComponent('pk-popover');
export const PkProgressIndicator = /*@__PURE__*/ createReactComponent('pk-progress-indicator');
export const PkProgressStatItem = /*@__PURE__*/ createReactComponent('pk-progress-stat-item');
export const PkRadio = /*@__PURE__*/ createReactComponent('pk-radio');
export const PkRadioOption = /*@__PURE__*/ createReactComponent('pk-radio-option');
export const PkSequence = /*@__PURE__*/ createReactComponent('pk-sequence');
export const PkSequenceItem = /*@__PURE__*/ createReactComponent('pk-sequence-item');
export const PkSidePanel = /*@__PURE__*/ createReactComponent('pk-side-panel');
export const PkSimpleHeader = /*@__PURE__*/ createReactComponent('pk-simple-header');
export const PkSpinner = /*@__PURE__*/ createReactComponent('pk-spinner');
export const PkTab = /*@__PURE__*/ createReactComponent('pk-tab');
export const PkTabPanel = /*@__PURE__*/ createReactComponent('pk-tab-panel');
export const PkTable = /*@__PURE__*/ createReactComponent('pk-table');
export const PkTableBody = /*@__PURE__*/ createReactComponent('pk-table-body');
export const PkTableCell = /*@__PURE__*/ createReactComponent('pk-table-cell');
export const PkTableHeader = /*@__PURE__*/ createReactComponent('pk-table-header');
export const PkTableHeaderCol = /*@__PURE__*/ createReactComponent('pk-table-header-col');
export const PkTableRow = /*@__PURE__*/ createReactComponent('pk-table-row');
export const PkTabs = /*@__PURE__*/ createReactComponent('pk-tabs');
export const PkToast = /*@__PURE__*/ createReactComponent('pk-toast');
export const PkToastItem = /*@__PURE__*/ createReactComponent('pk-toast-item');
//# sourceMappingURL=components.js.map